import { gql } from "@apollo/client";

export const ADD_QUERYPACK = gql`
  mutation AddQueryPack($input: [QueryPackAddInput!]!) {
    addQueryPack(input: $input)
  }
`;
